import { CSSObject } from '@emotion/react'
import { Color as GemColor, FontWeight } from '@opallabs/gem'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const addSectionColors: Record<string, string> = {
  default: colors.n4.base,
  hover: colors.n6.base,
  disabled: colors.n2.base,
}

type GetCarouselSectionArgs = {
  isReadOnly: boolean
  width: number
  shouldExit?: boolean
  index?: number
}

const getCarouselSection = ({
  width,
  isReadOnly,
  shouldExit,
  index,
}: GetCarouselSectionArgs): CSSObject => ({
  // position: 'relative',
  marginBottom: '20px',
  left: shouldExit && index === 0 ? '56px' : 0,
  listStyle: 'none',
  opacity: shouldExit && index !== 0 ? 0 : 1,
  position: shouldExit && index === 0 ? 'absolute' : 'relative',
  width: isReadOnly ? width : `calc(${width}px + 56px)`,
})

const getExpandedWrapper = (isReadOnly: boolean): CSSObject => ({
  columnGap: 25,
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  margin: '0 0 44px 0',
  padding: isReadOnly ? '20px 20px 0 20px' : 0,
  rowGap: 20,
  transformOrigin: 'top left',
})

const getAddSectionText = (status: string): CSSObject => ({
  color: addSectionColors[status],
  display: 'flex',
  fill: addSectionColors[status],
  flexFlow: 'column nowrap',
  fontFamily: fonts.proxima,
  fontSize: fontSizes.caps.medium,
  fontWeight: fontWeights.bold,
  justifyContent: 'center',
  rowGap: 17,
  textTransform: 'uppercase',
  transition: 'color 0.3s ease, fill 0.3s ease',
})

const getDropZone = (width: number): CSSObject => ({
  alignItems: 'center',
  backgroundColor: GemColor.dark.Translucent.A50,
  color: GemColor.dark.Text.Default,
  display: 'flex',
  fontSize: fontSizes.medium,
  fontWeight: FontWeight.Bold,
  height: 'calc(100% - 33px)',
  justifyContent: 'center',
  position: 'absolute',
  textTransform: 'uppercase',
  width: `${width}px`,
  zIndex: 1,
})

const styles = {
  getDropZone,
  getExpandedWrapper,
  getAddSectionText,
  getCarouselSection,
}

export { styles }
